import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=df276944&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df276944')) {
      api.createRecord('df276944', component.options)
    } else {
      api.reload('df276944', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=df276944&", function () {
      api.rerender('df276944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/sidebar/sidebar.vue"
export default component.exports